import { IBusinessCreateData } from '@/models/business';
import { BusinessOnboardingState } from '@/models/business-onboarding';

export function createBusinessPayload(
  data: BusinessOnboardingState
): Partial<IBusinessCreateData> {
  const { yourStore, storeDetails, yourBusinessCategory } = data;

  const { form: yourStoreFormData } = yourStore;
  const { form: storeDetailsFormData } = storeDetails;
  const { form: yourBusinessCategoryFormData } = yourBusinessCategory;

  return {
    name: storeDetailsFormData.businessName,
    locationName: storeDetailsFormData.locationName,
    type: yourStoreFormData.operationType,
    phone: storeDetailsFormData.phone.number,
    phoneCountryCode: storeDetailsFormData.phone.code,
    phoneCountryIso: storeDetailsFormData.phone.iso,
    website: storeDetailsFormData.website,
    merchantId: storeDetailsFormData.merchantId,
    country: yourStoreFormData.country.name || 'United States',
    countryIso2: yourStoreFormData.country.countryIso2 || 'US',
    categoryId: yourBusinessCategoryFormData.selectedCategory.id,
    otherCategory: yourBusinessCategoryFormData.selectedCategory.otherValue,
    businessLeadId: storeDetailsFormData.businessLeadId,
    ...(storeDetailsFormData.address && {
      address: storeDetailsFormData.address.address,
      addressAdditional: storeDetailsFormData.aditionalAddress,
      city: storeDetailsFormData.address.cityName,
      state: storeDetailsFormData.address.stateCode,
      zip: storeDetailsFormData.address.postCode,
      stateName: storeDetailsFormData.address.stateName,
      fullAddress: storeDetailsFormData.address.fullAddress
    })
  };
}
